import { InfoCard, InfoCardSkeleton, Typography } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

const Body = styled(Typography)`
  font-size: ${(p) => p.theme.text.fontSizes.l};
`;

type OverviewCardProps = {
  summary: string | null | undefined;
  isLoading: boolean;
};

export const OverviewCard = ({ summary, isLoading }: OverviewCardProps) => {
  if (isLoading) return <InfoCardSkeleton />;
  if (!summary) return null;

  return (
    <InfoCard title="Overview">
      <Body>{summary}</Body>
    </InfoCard>
  );
};
